import FormationCreate from './FormationCreate';
import FormationEdit from './FormationEdit';

export default {
  name: 'formations',
  create: FormationCreate,
  edit: FormationEdit,
};
